import { getHomeData, getIndexass } from '@/api/home'

export default {
  state: {
    homeData: '',
    hasStatus: false,
    urlStatus: false,
    homeIndex: ''
  },
  mutations: {
    setHome(state, data) {
      state.homeData = data
    },
    setHasStatus(state, data) {
      state.hasStatus = data
    },
    setUrlStatus(state, data) {
      state.urlStatus = data
    },
    setHomeIndex(state, data) {
      state.homeIndex = data
    }
  },
  getters: {},
  actions: {
    // 首页数据
    GetHome({ commit }) {
      return new Promise((resolve, reject) => {
        getHomeData()
          .then(response => {
            const data = response.data
            commit('setHome', data)
            commit('setHasStatus', true)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
    // 首页预览
    // GetIndex({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     getIndexass()
    //       .then(response => {
    //         const data = response.data
    //         // commit('setHomeIndex', data)
    //         commit('setHome', data)
    //         // commit('setHasStatus', true)
    //         resolve()
    //       })
    //       .catch(error => {
    //         reject(error)
    //       })
    //   })
    // }
  }
}
